import {useMemo} from 'react'
import {AutomatedCommentSource} from '../types'
import type {AutomatedComment} from '../types'

export function useAutomatedReviewCommentActions(automatedComment: Pick<AutomatedComment, 'isDismissed' | 'source'>) {
  return useMemo(() => {
    const isDismissed = automatedComment.isDismissed
    const showDismissButton = !isDismissed
    const showReopenButton = isDismissed

    let resourceName = 'alert'
    if (
      automatedComment.source === AutomatedCommentSource.CodeQuality ||
      automatedComment.source === AutomatedCommentSource.CodeScanningAi
    ) {
      resourceName = 'finding'
    }
    const isLicenseCompliance = automatedComment.source === AutomatedCommentSource.LicenseCompliance
    const toggleButtonLabel = isDismissed
      ? `Reopen ${resourceName}`
      : isLicenseCompliance
        ? `Close ${resourceName}`
        : `Dismiss ${resourceName}`

    return {
      isDismissed,
      showDismissButton,
      showReopenButton,
      resourceName,
      toggleButtonLabel,
    }
  }, [automatedComment])
}
